import SlWholesaleDiscount from '@/models/Sale/SlWholesaleDiscount'
import WhProduct from '@/models/Warehouse/WhProduct'
import axios from 'axios'
import API from '@/services/api/api'
// import axios from 'axios'
// import API from '@/services/api/api'

const fetchWholesaleDiscountsProduct = async function(productId) {
    try {

        let discountsProducts = await SlWholesaleDiscount.where('g_branch_office_id', 1)
            .where('wh_product_id', productId)
            .params({'get_all_results':true })
            .get()

        console.log('discountsProducts', discountsProducts)
        return discountsProducts.data
    } catch (error) {
        return error
        //return error.response.data
    }
}

const createWholeSaleDiscounts = async function(arrayDiscounts, productId) {
    try {
        let discountSchema = []
        for (let i = 0; i < arrayDiscounts.length; i++) {
            let currentDiscount = {}
            if (arrayDiscounts[i].discountType === 1) {
                // Percentage discount (%)
                currentDiscount = {
                    quantity_discount: parseInt(arrayDiscounts[i].quantity),
                    percentage_discount: parseInt(arrayDiscounts[i].discount),
                    unit_price_discount: 0,
                }
            } else {
                // Price discount ($)
                currentDiscount = {
                    quantity_discount: parseInt(arrayDiscounts[i].quantity),
                    percentage_discount: 0,
                    unit_price_discount: parseInt(arrayDiscounts[i].discount),
                }
            }
            discountSchema.push(currentDiscount)
        }

        let data = {
            wh_product_id: productId,
            g_branch_office_id: 1,
            discount_schema: discountSchema,
        }
        console.log('DATA', data)

        let wh = new SlWholesaleDiscount(data)
        let response = await wh.save()

        return response
    } catch (error) {
        //return error.response.data
        return error
    }
}

const updateWholesaleDiscounts = async function(arrayDiscounts, productId) {
    let discountSchema = []
    for (let i = 0; i < arrayDiscounts.length; i++) {
        let currentDiscount = {}
        if (arrayDiscounts[i].discountType === 1) {
            // Percentage discount (%)
            currentDiscount = {
                quantity_discount: parseInt(arrayDiscounts[i].quantity),
                percentage_discount: parseInt(arrayDiscounts[i].discount),
                unit_price_discount: 0,
            }
        } else {
            // Price discount ($)
            currentDiscount = {
                quantity_discount: parseInt(arrayDiscounts[i].quantity),
                percentage_discount: 0,
                unit_price_discount: parseInt(arrayDiscounts[i].discount),
            }
        }
        discountSchema.push(currentDiscount)
    }

    let data = {
        //wh_product_id: parseInt(productId),
        g_branch_office_id: 1, // id sucursal TODO: Desharcodear
        discount_schema: discountSchema,
    }
    console.log('data', data)
    try {
        let response = await axios.put(
            `${API.SL_WHOLESALE_DISCOUNT}/${productId}`,
            data
        )
        return response.data
    } catch (error) {
        return error
    }
}

const deleteWholesaleDiscounts = async function(productId) {

    let data = {
        g_branch_office_id: 1, // id sucursal TODO: Desharcodear
        discount_schema: [],
    }

    try {
        let response = await axios.put(
            `${API.SL_WHOLESALE_DISCOUNT}/${productId}`,
            data
        )
        return response.data
    } catch (error) {
        return error
    }
}

export default {
    fetchWholesaleDiscountsProduct,
    createWholeSaleDiscounts,
    updateWholesaleDiscounts,
    deleteWholesaleDiscounts,
}
